/* istanbul ignore file */

import { useMutation } from '@apollo/client';
import { ADD_PRODUCTS_TO_CREATE_CART } from './cartQyery';
import { PLACE_ORDER } from './orderQuery';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useLazyPlaceOrder = () => useMutation<any>(PLACE_ORDER);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useLazyCreateCart = () => useMutation<any>(ADD_PRODUCTS_TO_CREATE_CART);

export { useLazyCreateCart, useLazyPlaceOrder };
